const inteiro = value => typeof value === 'string' && /^[1-9][0-9]{0,19}$/.test(value);
const texto = value => typeof value === 'string' && value.trim().length > 0 && value.trim().length <= 1000 && !/[\x00-\x08\x0b\x0c\x0e-\x1f\x7f]/.test(value);
export function validarSequenciaForm(draft) {
    if (!draft || !inteiro(draft.proximaSequenciaNossoNumero)) return 'Informe um inteiro positivo com até 20 dígitos, sem espaços ou zeros à esquerda.';
    const anterior = draft.anterior;
    if (anterior !== null && !inteiro(anterior)) return 'A sequência atual não pôde ser validada. Atualize a consulta.';
    const nova = draft.proximaSequenciaNossoNumero;
    // Comparação exata de inteiros canônicos, sem conversão para Number.
    if (anterior !== null && (nova.length < anterior.length || (nova.length === anterior.length && nova <= anterior))) return 'A nova sequência deve ser maior que a atual. Não é permitido reduzir ou reiniciar.';
    if (!texto(draft.motivo)) return 'Informe o motivo, com até 1000 caracteres.';
    if (!texto(draft.referenciaBanco)) return 'Informe a referência da orientação bancária, com até 1000 caracteres.';
    if (typeof draft.versao !== 'string' || !/^[a-f0-9]{64}$/.test(draft.versao)) return 'Consulte a configuração atual antes de salvar.';
    return '';
}
export function dadosSequenciaForm(draft) {
    const erro = validarSequenciaForm(draft);
    if (erro) throw new Error(erro);
    return { proximaSequenciaNossoNumero: draft.proximaSequenciaNossoNumero, versao: draft.versao,
        motivo: draft.motivo.trim(), referenciaBanco: draft.referenciaBanco.trim() };
}
export function dataHoraSequencia(valor) {
    if (!valor) return 'Não informada';
    const data = new Date(valor);
    return Number.isNaN(data.getTime()) ? 'Não informada' : data.toLocaleString('pt-BR');
}
